import { Component } from '@angular/core';

@Component({
  selector: 'app-sales-outstanding-invoices',
  standalone: false,
  
  templateUrl: './sales-outstanding-invoices.component.html',
  styles: ``
})
export class SalesOutstandingInvoicesComponent {

}
